<template>
  <div id="app">
    <b-container>
      <psos-navbar></psos-navbar>
      <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>

      <alpha-note></alpha-note>
      <p></p>
      <b-nav v-if="'seq_id' in $route.params" tabs>
        <b-nav-item :to="{ name: 'seq-details' }">General</b-nav-item>
        <b-nav-item :to="{ name: 'features-view' }">Features</b-nav-item>
        <b-nav-item :to="{ name: 'homologies-view' }">Homologies</b-nav-item>
        <b-nav-item :to="{ name: 'references-view' }">References</b-nav-item>
        <b-nav-item :to="{ name: 'wordcloud-view' }">Wordcloud</b-nav-item>
      </b-nav>
    </b-container>

    <b-container>
      <router-view />
    </b-container>

    <psos-footer></psos-footer>
  </div>
</template>

<script>
import PsosNavbar from "@/components/PsosNavbar.vue";
import PsosFooter from "@/components/PsosFooter.vue";
import AlphaNote from "@/components/AlphaNote.vue";
import BreadcrumbMixin from "@/mixins/breadcrumb.vue";
export default {
  name: "PsovLayout",
  mixins: [BreadcrumbMixin],
  components: { PsosNavbar, PsosFooter, AlphaNote }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
